import MicroModal from 'micromodal';

const selectors = {
  zoomImage: '[data-image-zoom]',
  modalContainer: '[data-modal-container]',
  attrUnique: 'data-unique',
  image: 'data-src',
};

class GalleryZoom {
  constructor(container) {
    this.container = container;
    this.triggers = this.container.querySelectorAll(selectors.zoomImage);
    this.modalContainer = document.querySelector(selectors.modalContainer);

    this.init();
  }

  init() {
    this.triggers.forEach((trigger) => {
      const unique = trigger.getAttribute(selectors.attrUnique);
      const modalIsAdded = this.modalContainer.querySelector(`#zoom-${unique}`);

      if (modalIsAdded) {
        const newModal = this.container.querySelector(`#zoom-${unique}`);

        if (newModal) {
          modalIsAdded.parentNode.removeChild(modalIsAdded);
          this.modalContainer.appendChild(newModal);
        }
      }

      MicroModal.init({
        disableScroll: true,
        openTrigger: `data-popup-${unique}`,
        onShow: (modal) => {
          var images = modal.querySelectorAll(`[${selectors.image}]`, modal);
          images.forEach((image) => {
            if (image.getAttribute('src') === null) {
              const bigImage = image.getAttribute(selectors.image);
              image.setAttribute('src', bigImage);
            }
          });
        },
        onClose: (modal, el, event) => {
          event.preventDefault();
        },
      });
    });
  }
}

const galleryZoomSection = {
  onLoad() {
    new GalleryZoom(this.container);
  },
};

export default galleryZoomSection;
